import Cookies from 'js-cookie';
import { API_URL, ACCESS_TOKEN } from 'utils/constants';
import { http } from 'services';
import { authStore } from 'stores';

const client = http({
  baseURL: API_URL,
});

client.axiosInstance.interceptors.request.use(
  config => {
    const token = Cookies.get(ACCESS_TOKEN);

    if (token != null) {
      // eslint-disable-next-line no-param-reassign
      config.headers.token = token;
    }

    return config;
  },
  err => {
    return Promise.reject(err);
  },
);

client.axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response;

    if (status === 401) {
      authStore.signOut();
    }

    return Promise.reject(error);
  },
);

export default client;
